import { updateSelectedBookingWindowState } from './Data'

export function updateSelectedBookingWindow(bookingWindow) {
  return dispatch => {
    dispatch(updateSelectedBookingWindowState(bookingWindow))
  }
}
